<template>
  <v-toolbar
    v-if="$store.getters.currentMerchant"
    fixed
    dense
    class="toolbar rounded-1"
  >
    <div v-if="addBtn">
      <slot name="add">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="$emit('add')">
              <v-img
                src="/media/svg/icons/Files/metronic-file-plus.svg"
                :max-width="iconSize"
              ></v-img>
            </v-btn>
          </template>
          <span>جدید <kbd>ctrl</kbd> + <kbd>alt</kbd> + <kbd>n</kbd></span>
        </v-tooltip>
      </slot>
    </div>
    <span class="seprator" v-show="addBtn"></span>
    <div v-if="listBtn">
      <slot name="list">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="$emit('list')">
              <v-img
                src="/media/svg/icons/Files/metronic-files-list.svg"
                :max-width="iconSize"
              ></v-img>
            </v-btn>
          </template>
          <span>لیست </span>
        </v-tooltip>
      </slot>
    </div>
    <span class="seprator" v-show="listBtn"></span>
    <div v-if="saveBtn">
      <slot name="save">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="$emit('save')">
              <v-img
                src="/media/svg/icons/Files/metronic-file-save.svg"
                :max-width="iconSize"
              ></v-img>
            </v-btn>
          </template>
          <span>ذخیره <kbd>ctrl</kbd> + <kbd>alt</kbd> + <kbd>s</kbd> </span>
        </v-tooltip>
      </slot>
    </div>
    <span class="seprator" v-show="saveBtn"></span>
    <div v-if="returnBtn">
      <slot name="returnToList">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="$emit('returnToList')">
              <i class="fas fa-times" :max-width="iconSize"></i>
            </v-btn>
          </template>
          <span>
            انصراف و بازگشت به لیست <kbd>ctrl</kbd> + <kbd>alt</kbd> +
            <kbd>l</kbd></span
          >
        </v-tooltip>
      </slot>
    </div>
  </v-toolbar>
</template>

<script>
export default {
  name: 'Toolbar',
  props: {
    iconSize: {
      type: Number,
      default: 25,
    },
    addBtn: {
      type: Boolean,
      default: true,
    },
    listBtn: {
      type: Boolean,
      default: true,
    },
    saveBtn: {
      type: Boolean,
      default: true,
    },

    returnBtn: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar {
  margin-bottom: 1rem;
  border-radius: 4px !important;
  box-shadow: 0px 1.3px 0.9px -14px rgba(0, 0, 0, 0.031),
    0px 4.2px 3.1px -14px rgba(0, 0, 0, 0.052),
    0px 19px 14px -14px rgba(0, 0, 0, 0.11) !important;

  .seprator {
    height: 20px;
    width: 2px;
    background: #3699ff96;
    margin: 0 0.5rem;
  }
}
</style>
